import { useQuery } from '@tanstack/react-query';
import { timesheetService } from '@/services/timesheets/timesheetService';
import { timesheetQueryKeys } from './queryKeys';
import { useAuth } from '@/hooks/useAuth';
import { useCompanyTimezone } from '@/hooks/useCompanyTimezone';

export const useMyTimeEntries = (month?: Date) => {
  const { profile } = useAuth();
  const timezone = useCompanyTimezone();

  return useQuery({
    queryKey: timesheetQueryKeys.myTimeEntries(profile?.id || '', month, timezone),
    queryFn: () => timesheetService.getMyTimeEntries(profile?.id || '', month, timezone),
    enabled: !!profile?.id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
